import { Box, Typography } from '@mui/material';

import axiosApiInstance from '@/api/shared/axios-instance';
import URL_FACTORY from '@/helpers/url-helper';
import Seo from '@/components/shared/custom/seo-component';
import { Pages, Rutas } from '@/constants/rutas';
import {
    getCurrentSeason,
    getFantasyLaLigaProperties,
    GetJugadoresAdditionalData,
} from '@/components/jugadores-v2/information/jugadores-additional-data';
import { getMasterPhotoById } from '@/helpers/images-helper';
import { currentSeason } from '@/constants/site';
import { IsrRevalidateTime } from '@/constants/cache-state-constants';
import JugadoresPoints from '@/components/jugadores-v2/points/JugadoresPoints';

const JugadoresPage = ({ player, slug }) => {
    const nombre = player?.if?.nm;

    const season = getCurrentSeason();
    const title = `Estadísticas La Liga Fantasy Dazn de ${nombre} - ${season}`;
    const description = `Puntuaciones de ${nombre} en clave La Liga Fantasy Dazn, calendario, alineaciones probables, lesiones y noticias en clave La Liga Fantasy Dazn.`;
    const url = `${process.env.NEXT_PUBLIC_URL_FRONT}${Rutas.ESTADISTICAS_DEL_JUGADOR}/subidas-mercado-fantasy-biwenger/${slug}/${currentSeason}`;
    const image = getMasterPhotoById(player?.if?.id, 375);

    const properties = getFantasyLaLigaProperties(player);
    const customSeoSchema = GetJugadoresAdditionalData(player, url, properties);

    return (
        <Box className="container" mt={2}>
            <Seo
                pageId={Pages.JUGADORES}
                title={title}
                image={image}
                url={url}
                description={description}
                summary={'summary'}
                customSeoSchema={customSeoSchema}
                width={500}
                height={500}
            />

            <Typography variant="h1">
                {nombre} - Puntos de La Liga Fantasy Dazn {season}
            </Typography>

            <JugadoresPoints player={player} slug={slug} />
        </Box>
    );
};

export default JugadoresPage;

/**
 * getStaticProps con ISR
 *
 * Se ejecuta en el build y se revalida automáticamente cada cierto tiempo.
 */
export async function getStaticProps({ params }) {
    const { slug } = params;

    if (!slug || slug.length === 0) {
        return {
            notFound: true,
        };
    }

    const playerSlug = slug?.[0];
    const year = slug?.[1] ?? currentSeason;

    let response = {};

    try {
        const url = URL_FACTORY.GetFantasyPoints;

        const payload = {
            slug: playerSlug,
            season: year,
        };

        response = await axiosApiInstance.post(url, payload);
    } catch (error) {
        console.error('Error fetching player profile:', error);
        return {
            notFound: true,
        };
    }

    const player = response?.data ?? {};

    return {
        props: {
            slug: playerSlug,
            player: player,
        },
        revalidate: IsrRevalidateTime.JUGADORES_PAGE, // Tiempo de revalidación
    };
}

/**
 * getStaticPaths con fallback
 *
 * No pre-generamos rutas específicas, pero permitimos generarlas bajo demanda.
 */
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking', // Si la página no existe, la genera dinámicamente
    };
}
